import { Box, Typography } from '@mui/material';
import { WithTranslation, withTranslation } from 'react-i18next';
import { format } from 'date-fns';

import { useMytaverse } from '@providers/MytaverseProvider';
import { IMessage, MessageType } from '@core/assistant/interfaces';
import Tag from '@core/assistant/Tag';

import { useStyles } from './styles';

interface IMessageTranslate extends WithTranslation {
  message: IMessage;
}

const Message = ({ message, t: translate }: IMessageTranslate) => {
  const classes = useStyles();

  const { user } = useMytaverse();

  const { type, timestamp, text } = message;
  const isAssistantMessage = type === MessageType.ASSISTANT;

  const userName = user?.firstName || user?.name || translate('assistant.user');

  return (
    <Box sx={classes.box(isAssistantMessage)}>
      <Box sx={classes.content}>
        <Box sx={classes.header}>
          <Box sx={classes.headerName}>
            <Typography sx={classes.name}>
              {isAssistantMessage ? translate('assistant.noa') : userName}
            </Typography>
            {isAssistantMessage ? <Tag /> : null}
          </Box>

          <Typography sx={classes.time}>
            {format(new Date(timestamp), 'h:mm:ss a')}
          </Typography>
        </Box>
        <Typography sx={classes.text}>{text}</Typography>
      </Box>
    </Box>
  );
};

export default withTranslation('common')(Message);
